module.exports = __webpack_public_path__ + "static/media/8.c9d7e945.jpg";